import { render } from "./feature.vue?vue&type=template&id=038b1e2a"
import script from "./feature.vue?vue&type=script&lang=js"
export * from "./feature.vue?vue&type=script&lang=js"

import "./feature.vue?vue&type=style&index=0&id=038b1e2a&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__